var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 291,
    viewBox: "0 0 290 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8227 218.25C56.8852 218.25 48.729 204.073 58.6977 186.749L126.875 68.2578C136.844 50.9297 153.156 50.9297 163.125 68.2578L231.302 186.749C241.271 204.078 233.115 218.25 213.177 218.25H76.8227Z",
    fill: "#ED6C02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.062 145.5C154.062 150.524 150.007 154.594 145 154.594C139.993 154.594 135.938 150.524 135.938 145.5V109.125C135.938 104.101 139.993 100.031 145 100.031C150.007 100.031 154.062 104.101 154.062 109.125V145.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.062 181.875C154.062 186.899 150.007 190.969 145 190.969C139.993 190.969 135.938 186.899 135.938 181.875C135.938 176.851 139.993 172.781 145 172.781C150.007 172.781 154.062 176.851 154.062 181.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 291,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3643e10dd92f621408ff73bc8ecc408a.svg";
export { ForwardRef as ReactComponent };